import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { groupSupplierDocuments } from 'features/supplier/utils';

import CommonImage from '@components/CommonImage';

import AddSupportingDocuments from '@features/supplier/component/AddSupportingDocuments';
import ViewDocuments from '@features/supplier/component/ViewDocuments';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { useSupplierDocuments } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { fetchEnumValues } from '@services/commonService';
import { getSupplierDocuments, removeSupplierDocuments } from '@services/supplierOnboardingService';

import {
	changeDateFormat,
	getFileType,
	getIconByFileType,
	getShortName,
	printApiError,
	replaceSymbols
} from '@utils/Util';

const AdditionalDocuments = () => {
	const documents = useSupplierDocuments();
	const [documentTypes, setDocumentTypes] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();
	const [isAdd, onSetAdd] = useState(false);
	const [isShowView, setIsShowView] = useState(false);
	const [selectedDocuments, setSelectedDocuments] = useState([]);

	const fetchDocumentTypes = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchEnumValues('info.nitex.app.supplier.SupportingDocumentType');
			setDocumentTypes(data?.map((item) => ({ id: item.constant, value: item.name })));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	useEffect(() => {
		(async () => {
			await Promise.all([fetchDocumentTypes()]);
		})();
	}, [id]);

	const onRemoveDocument = async (docId) => {
		try {
			dispatch(openLoader());
			await removeSupplierDocuments(id, docId);
			setSelectedDocuments(selectedDocuments.filter((item) => item.documentResponse.id !== docId));
			await dispatch(getSupplierDocuments(id));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	const renderDocuments = () => {
		if (documents?.supportingDocumentList?.length > 0) {
			const groupedDocuments = groupSupplierDocuments(
				documents.supportingDocumentList,
				'supportingDocumentType'
			);

			return Object.keys(groupedDocuments)?.map((item) => {
				let sortredData = groupedDocuments[item].sort((a, b) => {
					return b.documentResponse.id - a.documentResponse.id;
				});
				return (
					<div
						className="single text-left same-padding-box d-flex flex-column justify-content-center"
						key={`supporting_doc_${item}`}
						onClick={() => {
							setSelectedDocuments(sortredData);
							setIsShowView(true);
						}}
					>
						<p className="gray_dark_01 weight-700 regular-14">{replaceSymbols(item, '_', ' ')}</p>
						{sortredData?.slice(0, 1)?.map((doc) => {
							let fileType;
							if (doc.documentResponse.docUrl) {
								fileType = getFileType(doc.documentResponse.docUrl);
							} else {
								fileType = getFileType(doc.documentResponse.name);
							}
							return (
								<div
									key={`doc_${doc.documentResponse.id}`}
									className="addition-info d-flex align-items-center cursor-pointer pt-1"
								>
									<div>
										{doc?.expiryDate && (
											<p className="regular-14 gray_dark_02 pb-2">
												Expiry Date{' '}
												{changeDateFormat(doc.expiryDate, '', 'DD MMM, YYYY')}
											</p>
										)}
										<div className="d-flex align-items-center">
											<CommonImage
												src={getIconByFileType(fileType)}
												alt=""
												width={19}
												isStatic={false}
												onClick={() =>
													window.open(doc.documentResponse.docUrl, '_blank')
												}
											/>
											<div>
												<p
													className="regular-12 pl-1"
													onClick={() =>
														window.open(doc.documentResponse.docUrl, '_blank')
													}
												>
													{getShortName(doc.documentResponse.name, 20)}
												</p>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				);
			});
		}
	};

	return (
		<>
			<div className="section-padding hover-section">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Additional documents
					<span className="ml-12">
						<button
							className="blue border-0 medium-14 bg-transparent"
							onClick={() => onSetAdd(true)}
						>
							Add
						</button>
					</span>
				</h3>
				<div className="info-items_bottom">{renderDocuments()}</div>
			</div>
			{isAdd && (
				<AddSupportingDocuments
					onClose={() => onSetAdd(false)}
					documentResponseList={documents?.supportingDocumentList || []}
					documentTypes={documentTypes}
					callBack={() => dispatch(getSupplierDocuments(id))}
				/>
			)}
			{isShowView && (
				<ViewDocuments
					onClose={() => {
						setSelectedDocuments([]);
						setIsShowView(false);
					}}
					title="Additional Documents"
					onRemoveClick={onRemoveDocument}
					documentList={selectedDocuments}
				/>
			)}
		</>
	);
};

export default AdditionalDocuments;
